import { Button, useSnackbarSpace } from '@hue/design-system';
import type { StepState } from './guide-model.js';
import type { GuideStep } from './guide-types.js';

/// O roteiro recolhido: a pessoa trabalha na tela de baixo e continua vendo o que está fazendo.
/// À esquerda do "voltar ao topo", que mora no canto direito.
export function GuideDock({
  guideTitle,
  step,
  state,
  position,
  total,
  hasNext,
  onReopen,
  onNext,
}: {
  guideTitle: string;
  step: GuideStep;
  state: StepState;
  position: number;
  total: number;
  hasNext: boolean;
  onReopen: () => void;
  onNext: () => void;
}) {
  const snackbarSpace = useSnackbarSpace();
  const label = step.appendix ? 'Anexo' : `Passo ${String(position)} de ${String(total)}`;
  const line =
    state.kind === 'measured-done'
      ? `Concluído: ${state.text}`
      : 'text' in state
        ? state.text
        : step.title;
  return (
    <section
      aria-label="Roteiro recolhido"
      style={snackbarSpace > 0 ? { bottom: Math.max(80, snackbarSpace + 12) } : undefined}
      className="fixed inset-x-3 bottom-20 z-40 flex flex-wrap items-center gap-3 rounded-2xl border border-brand-500/60 bg-surface-card px-4 py-3 shadow-[0_12px_32px_rgba(0,0,0,.25)] sm:inset-x-auto sm:bottom-5 sm:right-20 sm:w-[30rem]"
    >
      <div role="status" className="min-w-44 flex-1">
        <p className="text-xs text-content-muted">
          {guideTitle} · {label}: {step.title}
        </p>
        <p className="text-sm font-semibold leading-5">{line}</p>
      </div>
      {state.kind === 'measured-done' && hasNext ? (
        <Button size="sm" onClick={onNext}>
          Próximo passo
        </Button>
      ) : (
        <Button size="sm" variant="outline" onClick={onReopen}>
          Voltar ao roteiro
        </Button>
      )}
    </section>
  );
}
